"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    margin: 10,
    borderColor: theme.borderColor || '#e6e6e6',
    color: theme.labelColor || 'black'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var ObjectType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ObjectType, _React$Component);

  function ObjectType() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ObjectType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ObjectType)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (value) {
      var onChange = _this.props.onChange;
      var withReplacedQuotes = value.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
      var newState = {
        jsonString: withReplacedQuotes
      };

      try {
        newState.json = JSON.parse(withReplacedQuotes.trim());
        onChange(newState.json);
        _this.failed = false;
      } catch (err) {
        _this.failed = true;
      }

      _this.setState(newState);
    };

    _this.state = {};
    return _this;
  }

  _createClass(ObjectType, [{
    key: "getJSONString",
    value: function getJSONString() {
      var _this$state = this.state,
          json = _this$state.json,
          jsonString = _this$state.jsonString;
      var knob = this.props.knob; // If there is an error in the JSON, we need to give that errored JSON.

      if (this.failed) return jsonString; // If the editor value and the knob value is the same, we need to return the
      // editor value as it allow user to add new fields to the JSON.

      if ((0, _deepEqual["default"])(json, knob.value)) return jsonString; // If the knob's value is different from the editor, it seems like
      // there's a outside change and we need to get that.

      return JSON.stringify(knob.value, null, 2);
    }
  }, {
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      var jsonString = this.getJSONString();
      var extraStyle = {};

      if (this.failed) {
        extraStyle.borderWidth = 1;
        extraStyle.borderColor = '#fadddd';
        extraStyle.backgroundColor = '#fff5f5';
      }

      return _react["default"].createElement(Input, {
        id: knob.name,
        style: extraStyle,
        value: jsonString,
        onChangeText: this.handleChange,
        multiline: true,
        autoCapitalize: "none",
        underlineColorAndroid: "transparent"
      });
    }
  }]);

  return ObjectType;
}(_react["default"].Component);

ObjectType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
ObjectType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array])
  }),
  onChange: _propTypes["default"].func
};

ObjectType.serialize = function (object) {
  return JSON.stringify(object);
};

ObjectType.deserialize = function (value) {
  return value ? JSON.parse(value) : {};
};

var _default = ObjectType;
exports["default"] = _default;